<app-form-group class="{{info.classes}} position-relative" [ngClass]="{'disabled': info.disabled}"
                [omitVerticalPadding]="!!info.subLabel">
  <label [ngClass]="!last ? 'line-before' : ''" class="d-flex position-relative row g-0 gx-2" for="{{info.id}}">
    <app-sequence-badge class="col-auto" [index]="index"></app-sequence-badge>
    <div class="col">
      {{ info.label }}
      <span [ngClass]="{'required': info.required()}"></span>
      @if (info.info) {
        <app-info>
          <span class="tooltipContent">{{ info.info }}</span>
        </app-info>
      }
    </div>
    @if (info.subLabel) {
      <div class="col-12 ellipsis" style="font-size: smaller; margin-left: 1.9rem;">{{ info.subLabel }}</div>
    }
  </label>
  <div id="{{info.id}}" [style]="'margin-top: ' + info.readonly ? '8px' : 0">
    <ng-container #holder></ng-container>
  </div>
</app-form-group>
